import { store } from "../redux/store";

import { createOnlineOrderTracker, TrackedOrder } from "./onlineOrderTracker";
import { playOnlineOrderSound } from "./onlineOrderSound";

/**
 * Склейка: список заказов подписки «все» → трекер новизны → звук, если
 * включено в настройках заказа. Трекер работает всегда (и при выключенной
 * опции), чтобы включение опции не озвучивало уже висящие заказы.
 */

const tracker = createOnlineOrderTracker();

export function notifyNewOnlineOrders(models: TrackedOrder[]) {
	const freshIds = tracker.track(models);
	if (!freshIds.length) return;

	const settings = (store.getState() as any)?.settings?.order?.general
		?.notifyOnlineOrders;
	if (!settings?.active) return;

	playOnlineOrderSound(settings.sound ?? null).catch(() => undefined);
}

export { tracker as onlineOrderTracker };
